import { Component, OnInit } from '@angular/core';
/** la funcionalidad de este componente esta en su html: marca la recervación como exitosa  */
@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.css']
})
export class ReceiptComponent implements OnInit {

  constructor() { }

  ngOnInit() {console.clear();
  }

}
